var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2485_5506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75541 2.79136C9.10184 2.12417 8.04112 2.12417 7.38755 2.79136L2.45898 7.82261C1.3313 8.97378 1.3313 10.8386 2.45898 11.9898C3.58666 13.141 5.41344 13.141 6.54112 11.9898L10.6125 7.83354C10.9045 7.5355 11.3813 7.5355 11.6733 7.83354C11.9652 8.13159 11.9652 8.61831 11.6733 8.91636L7.60183 13.0726C5.88755 14.8226 3.11255 14.8226 1.39826 13.0726C-0.316023 11.3226 -0.316023 8.48979 1.39826 6.73979L6.32684 1.70854C7.56701 0.442529 9.57594 0.442529 10.8161 1.70854C12.0563 2.97456 12.0563 5.02534 10.8161 6.29136L6.10184 11.1039C5.33576 11.8859 4.09291 11.8859 3.32683 11.1039C2.56076 10.3218 2.56076 9.05308 3.32683 8.27104L7.18398 4.33354C7.47594 4.0355 7.95273 4.0355 8.24469 4.33354C8.53666 4.63159 8.53666 5.11831 8.24469 5.41636L4.38755 9.35386C4.20809 9.53706 4.20809 9.83784 4.38755 10.021C4.56701 10.2042 4.86166 10.2042 5.04112 10.021L9.75541 5.20854C10.409 4.54136 10.409 3.45854 9.75541 2.79136Z",
    fill: "#596873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2485_5506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.0cb68edb8674a5f07972c27526fb271e.svg";
export { ForwardRef as ReactComponent };